/**
 * The addresses the legal pages publish. One place, because a policy that names an address the
 * site does not actually read is worse than no policy.
 */
export const CONTACT_EMAIL = 'contact@thottbot4ever.com';
export const PRIVACY_EMAIL = 'privacy@thottbot4ever.com';
export const DMCA_EMAIL = 'dmca@thottbot4ever.com';

/** Shown as the "last updated" line; bump when the substance of a policy changes. */
export const POLICY_UPDATED = '23 September 2026';

export const OPERATOR = 'the Thottbot Forever team';
